<template>
  <div class="top-bar">
    <div class="user">
      <div class="avatar">
        <img class="img" :src="data.avatar || require('assets/imgs/padom.png')"></img>
      </div>
      <div class="user-info">
        <span class="name">{{data.nickname || '游客'}}</span>
        <div class="extra-info">
          <span><i>{{data.follow_count}}</i>关注</span>
          <span><i>{{data.be_follow_count}}</i>粉丝</span>
          <span><i>{{data.like_count}}</i>获赞</span>
        </div>
      </div>
      <div class="oparate-view">
        <button v-if="!data.is_it_self" class="btn oparate-btn" @click.prevent="oparate('follow')"  :class=" data.followed ? 'followed-btn' : 'follow-btn'">
          {{data.followed ? '已关注':'+关注'}}
        </button>
        <button v-if="!data.is_it_self" class="btn publish-btn" @click.prevent="oparate('publish')">向TA报料</button>
        <!-- <button v-if="!data.is_it_self" class="btn follow-btn" :class="{em: data.followed}" @click.prevent="oparate('follow')"><i class="iconfont" :class="data.followed ? 'icon-guanzhu' : 'icon-guanzhu1'"></i>{{data.followed ? '已关注':'关注'}}</button> -->
        <!-- <button v-if="data.is_it_self" class="btn quit-btn" @click.prevent="oparate('exit')"><i class="iconfont icon-tuichu"></i>退出</button> -->
      </div>
    </div>
  </div>
</template>
<script>
  import { follow } from 'assets/js/community.js';
  export default {
    name: 'TopBar',
    props: ['user'],
    data(){
      return {
        data: this.user
      }
    },
    computed:{
      tokens(){
        return this.$store.state.tokens;
      }
    },
    created(){
      // console.log('user:' ,this.data);
    },
    methods:{
      
      async oparate(type){
        let that = this;
        
        
        switch(type){
          case 'follow':
            follow(this.data.id,tokens).then(res=>{
              let temp = this.data;
              this.data = Object.assign({}, temp, {followed: res.data.followed});
            });
          break;
          case 'publish':
            this.$router.push({
              name: 'Publish',
              params:{
                id: 99
              }
            })
          break;
          case 'exit':
            this.$store.dispatch('clearAuth');
            this.$emit('updateProfile');
          break;
          default:
          break;
        }
      }
    }
  }
</script>
<style lang="scss">
  .top-bar{
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    width: 100vw;
    padding: 1.4em 1em .9em;
    background: url('~assets/imgs/bg2.png') center center no-repeat;
    background-size: 100% 100%;
  }
  .topbg{
      position: absolute;
      left: 0;
      top:0;
      z-index: 1;
      width: 100%;
    }
  .user{
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .avatar{
      margin-right: .5em;
      .img{
        width: 13.3vw;
        height: 13.3vw;
        border-radius: 100%;
        border: 1px solid #fff;
        background: #fff;
      }
    }
  }
  .user-info{
    color: #333;
    color: #fff;
    .name, .btn{
      display: block;
      font-size: 1em;
      text-align: left;
    }
    .name{
      line-height: 1;
      margin: .2em 0;
    }
    .btn{
      display: block;
      padding: 0 1em 0 0;
      color: #fff;
    }
    .extra-info{
      width: 45vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      flex: 1;
      font-size: .8em;
      line-height: 1.1;
      margin-top: .5em;
      i{
        font-style: normal;
        display: block;
      }
    }
  }
  .oparate-view{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    .btn{
      display: block;
      padding: 0 1em;
      background-color: #ffeeee;
      color: #e65757;
      height: 8vw;
      line-height: 8vw;
      border-radius: 8vw;
      margin: .5em auto;
      font-weight: 700;
    }
    .oparate-btn{
      width: 18.6vw;
      white-space: nowrap;
      border-radius: 8vw;
      background-color: #ffeeee;
      color: #e65757;
      font-weight: 700;
    }
    .followed-btn{
      background-color: #eff3f7;
      color: #aab5c4;
    }
  }
  
  .quit-btn{
    
  }
</style>